import { cn } from "web-design-system";
import { getInitials } from "creso-core/utils";

export function BrandLogo({
  url,
  name,
  className,
}: {
  url?: string | null;
  name: string;
  className?: string;
}) {
  if (url) {
    return (
      <img
        src={url}
        alt={`${name} logo`}
        className={cn("object-contain shrink-0", className)}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center shrink-0 bg-violet-100 text-violet-700 font-semibold",
        className
      )}
    >
      {getInitials(name)}
    </div>
  );
}
